// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { startOfDecade as fn } from "../startOfDecade.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const startOfDecade = convertToFP(fn, 1);

// Fallback for modularized imports:
export default startOfDecade;
